export const generateRandomString = (length: number): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  return Array.from({ length })
    .map(() => {
      const randomIndex = Math.floor(Math.random() * characters.length)
      return characters[randomIndex]
    })
    .join('')
}
